import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { solutionsData } from '../mock';
import { Card, CardContent } from './ui/card';
import { ArrowRight } from 'lucide-react';

const Solutions = () => {
  const { t } = useLanguage();

  return (
    <section id="solutions" className="py-20 medical-section-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1592218698237-5bd1aef5e3e7)` }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.solutions.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t.solutions.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {t.solutions.items.map((solution, index) => (
            <Card 
              key={index}
              className="card-hover border-none shadow-lg overflow-hidden"
              style={{ animationDelay: `${index * 0.1}s`, borderRadius: '16px' }}
            >
              <CardContent className="p-6">
                <h3 className="text-2xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
                  {solution.title}
                </h3>
                
                {/* Image Grid */}
                <div className="grid grid-cols-2 gap-3 mb-4">
                  {solutionsData[index].images.map((img, idx) => (
                    <div key={idx} className="h-40 rounded-xl overflow-hidden">
                      <img 
                        src={img}
                        alt={`${solution.title} ${idx + 1}`}
                        className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                  ))}
                </div>

                <p className="text-gray-700 leading-relaxed mb-4">
                  {solution.description}
                </p>

                <button 
                  className="text-[#2D4A8F] font-semibold flex items-center space-x-2 hover:space-x-3 transition-all"
                >
                  <span>{t.solutions.learnMore}</span>
                  <ArrowRight size={18} />
                </button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
